import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, HostBinding, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@storeblocks/button-ng';
import { ButtonModule } from '@storeblocks/button-ng';
const _c0 = ["toastContainer"];
const _c1 = ["*"];
function ToastComponent_ng_container_0_div_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function ToastComponent_ng_container_0_div_1_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onButtonClicked());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("stbButton", "text-dark-mode")("setIconAfter", true)("iconType", "arrow-right");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
  }
}
function ToastComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3, 0)(2, "div", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ToastComponent_ng_container_0_div_1_button_4_Template, 2, 4, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("flexmode", ctx_r1.flexMode)("single", !ctx_r1.flexMode)("rebrand", ctx_r1.rebrand);
    i0.ɵɵproperty("id", ctx_r1.uniqueId);
    i0.ɵɵattribute("data-trackid", ctx_r1.trackId);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasButton);
  }
}
function ToastComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ToastComponent_ng_container_0_div_1_Template, 5, 10, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.visible);
  }
}
function ToastComponent_ng_container_1_div_1_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 14);
    i0.ɵɵtext(1, "information");
    i0.ɵɵelementEnd();
  }
}
function ToastComponent_ng_container_1_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
  }
}
function ToastComponent_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8, 0)(2, "div", 9);
    i0.ɵɵtemplate(3, ToastComponent_ng_container_1_div_1_i_3_Template, 2, 0, "i", 10);
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵtemplate(5, ToastComponent_ng_container_1_div_1_div_5_Template, 2, 1, "div", 12);
    i0.ɵɵelementStart(6, "div", 13);
    i0.ɵɵtext(7);
    i0.ɵɵprojection(8);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("fluid", ctx_r1.fluid);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("fluid", ctx_r1.fluid);
    i0.ɵɵattribute("data-variant", ctx_r1.variant)("id", ctx_r1.uniqueId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
  }
}
function ToastComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ToastComponent_ng_container_1_div_1_Template, 9, 9, "div", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.visible);
  }
}
let ToastComponent = /*#__PURE__*/(() => {
  class ToastComponent {
    constructor(renderer) {
      this.renderer = renderer;
      this.buttonText = 'Button';
      this.trackId = 'stb-toast';
      this.closeNow = false;
      this.flexMode = false;
      this.fluid = false;
      this.variant = 'info';
      this.rebrand = false;
      this.toastFadedOut = new EventEmitter();
      this.buttonClicked = new EventEmitter();
      this.visible = true;
      this.isMobile = false;
    }
    get isRebrand() {
      return this.rebrand;
    }
    ngOnInit() {
      // set unique id's in case of multiple toasts queued up
      if (!this.uniqueId) {
        this.uniqueId = 'stb-toast-' + Math.floor(Math.random() * 999999);
      }
    }
    ngAfterViewInit() {
      this.setUpTimer();
      setTimeout(() => {
        this.renderer.addClass(this.container.nativeElement, 'fadedIn');
        this.visible = true;
      }, 50);
    }
    ngOnChanges() {
      if (this.closeNow === true) {
        this.fadeOutAndDestroy();
      }
    }
    ngOnDestroy() {
      this.fadeOutAndDestroy();
    }
    setUpTimer() {
      // auto-dismissal of toast
      let delay = 0;
      switch (this.duration) {
        case 'short':
          delay = 4;
          break;
        case 'medium':
          delay = 7;
          break;
        case 'long':
          delay = 10;
          break;
        default:
          delay = Infinity;
      }
      if (delay !== Infinity) {
        setTimeout(() => {
          this.fadeOutAndDestroy();
        }, delay * 1000);
      }
    }
    onButtonClicked() {
      this.buttonClicked.emit();
    }
    fadeOutAndDestroy() {
      // toast may have been dismissed by user already, check first
      if (this.container?.nativeElement) {
        this.renderer.addClass(this.container.nativeElement, 'fadedOut');
      }
      // Wait for transistion to end before calling destroy()
      // works best if using closeNow input (not *ngIf)
      if (this.visible) {
        this.container.nativeElement.addEventListener('transitionend', () => {
          this.destroy();
        }, {
          once: true
        });
      }
    }
    destroy() {
      this.visible = false;
      this.toastFadedOut.emit(true);
    }
    close() {
      this.fadeOutAndDestroy();
    }
  }
  ToastComponent.ɵfac = function ToastComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  ToastComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToastComponent,
    selectors: [["stb-toast"]],
    viewQuery: function ToastComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function ToastComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("rebrand", ctx.isRebrand);
      }
    },
    inputs: {
      duration: "duration",
      title: "title",
      text: "text",
      hasButton: "hasButton",
      buttonText: "buttonText",
      uniqueId: "uniqueId",
      trackId: "trackId",
      closeNow: "closeNow",
      flexMode: "flexMode",
      fluid: "fluid",
      variant: "variant",
      rebrand: "rebrand"
    },
    outputs: {
      toastFadedOut: "toastFadedOut",
      buttonClicked: "buttonClicked"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c1,
    decls: 2,
    vars: 2,
    consts: [["toastContainer", ""], [4, "ngIf"], ["class", "stb-toast-container", "aria-live", "polite", "role", "status", "aria-live", "polite", "tabindex", "0", 3, "flexmode", "single", "rebrand", "id", 4, "ngIf"], ["aria-live", "polite", "role", "status", "aria-live", "polite", "tabindex", "0", 1, "stb-toast-container", 3, "id"], [1, "stb-toast-body-container"], [3, "stbButton", "setIconAfter", "iconType", "click", 4, "ngIf"], [3, "click", "stbButton", "setIconAfter", "iconType"], ["class", "toasterContainer", 3, "fluid", 4, "ngIf"], [1, "toasterContainer"], ["aria-live", "polite", 1, "toastBase"], ["class", "icon icon-medium", 4, "ngIf"], [1, "toastContent"], ["class", "font-paragraph toastTitle", "style", "font-weight: 600;", 4, "ngIf"], [1, "font-paragraph", "toastBody"], [1, "icon", "icon-medium"], [1, "font-paragraph", "toastTitle", 2, "font-weight", "600"]],
    template: function ToastComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ToastComponent_ng_container_0_Template, 2, 1, "ng-container", 1)(1, ToastComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.rebrand);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.rebrand);
      }
    },
    dependencies: [i1.NgIf, i2.StbButtonDirective, i2.ButtonComponent],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}.rebrand[_nghost-%COMP%]   .toasterContainer[_ngcontent-%COMP%]{z-index:1000}.rebrand[_nghost-%COMP%]   .toasterContainer.fluid[_ngcontent-%COMP%]{width:clamp(288px,100%,560px)}.rebrand[_nghost-%COMP%]   .toasterContainer.fadedIn[_ngcontent-%COMP%]{opacity:1;transition:opacity .2s ease-in}.rebrand[_nghost-%COMP%]   .toasterContainer.fadedOut[_ngcontent-%COMP%]{opacity:0;transition:opacity .4s ease-in-out}@media only screen and (max-width: 767px){.rebrand[_nghost-%COMP%]   .toasterContainer[_ngcontent-%COMP%]{bottom:var(--p-spacing-16);left:50%;margin-left:-144px;max-width:288px;min-width:288px;position:absolute}.rebrand[_nghost-%COMP%]   .toasterContainer[_ngcontent-%COMP%]   i.icon.icon-medium[_ngcontent-%COMP%]{font-size:20px!important;line-height:20px!important;width:20px;height:20px}}@media only screen and (min-width: 768px){.rebrand[_nghost-%COMP%]   .toasterContainer[_ngcontent-%COMP%]{position:absolute;right:var(--p-spacing-24, 24px);top:var(--p-spacing-24, 24px)}}.rebrand[_nghost-%COMP%]   .icon[_ngcontent-%COMP%]{position:relative;top:1px}.rebrand[_nghost-%COMP%]   .toastBase[_ngcontent-%COMP%]{--stb-toast-bg: #000;--stb-toast-fg: #fff;background-color:var(--stb-toast-bg);border-radius:var(--p-corner-radius-small, 8px);border:none;box-shadow:0 4px 8px #00000047;color:var(--stb-toast-fg);display:flex;gap:var(--p-spacing-16, 16px);max-height:235px;padding:var(--p-spacing-24);transition:opacity .2s ease-in;width:416px}.rebrand[_nghost-%COMP%]   .toastBase[_ngcontent-%COMP%]   .toastTitle[_ngcontent-%COMP%], .rebrand[_nghost-%COMP%]   .toastBase[_ngcontent-%COMP%]   .toastBody[_ngcontent-%COMP%]{color:var(--stb-toast-fg)}.rebrand[_nghost-%COMP%]   .toastBase[_ngcontent-%COMP%]   .toastTitle[_ngcontent-%COMP%] + .toastBody[_ngcontent-%COMP%]{margin-top:var(--p-spacing-04)}.rebrand[_nghost-%COMP%]   .toastBase.fluid[_ngcontent-%COMP%]{width:clamp(288px,100%,560px)}.rebrand[_nghost-%COMP%]   .toastBase[data-variant=error][_ngcontent-%COMP%]{--stb-toast-bg: var(--p-color-surface-error);--stb-toast-fg: var(--p-color-text-alert)}.rebrand[_nghost-%COMP%]   .toastBase[data-variant=info][_ngcontent-%COMP%]{--stb-toast-bg: var(--p-color-surface-info);--stb-toast-fg: var(--p-color-grey-900)}.rebrand[_nghost-%COMP%]   .toastBase[data-variant=success][_ngcontent-%COMP%]{--stb-toast-bg: var(--p-color-surface-success);--stb-toast-fg: var(--p-color-grey-900)}.rebrand[_nghost-%COMP%]   .toastBase[data-variant=warning][_ngcontent-%COMP%]{--stb-toast-bg: var(--p-color-surface-warning);--stb-toast-fg: var(--p-color-grey-900)}.rebrand[_nghost-%COMP%]   .toastBase[data-variant=neutral][_ngcontent-%COMP%]{--stb-toast-bg: var(--p-color-surface-white);--stb-toast-fg: var(--p-color-grey-900)}.stb-toast-container[_ngcontent-%COMP%]{padding-top:16px;font-size:14px;font-weight:400;line-height:24px;font-family:Open Sans;border-radius:2px;box-shadow:0 4px 6px #00000024,0 6px 8px #0000001f;width:288px;background-color:#191919;color:#fff;opacity:0;transition:opacity}.stb-toast-container.fadedIn[_ngcontent-%COMP%]{opacity:1;transition:opacity .2s ease-in}.stb-toast-container.fadedOut[_ngcontent-%COMP%]{opacity:0;transition:opacity .4s ease-in-out}.stb-toast-container[_ngcontent-%COMP%]   .stb-toast-body-container[_ngcontent-%COMP%]{margin:0 16px 16px}.stb-toast-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding-top:4px;padding-bottom:4px;padding-left:16px;margin:0;min-height:48px}.stb-toast-container[_ngcontent-%COMP%]:focus-visible{outline:2px solid #00f;outline-offset:4px}@media only screen and (max-width: 767px){.stb-toast-container.single[_ngcontent-%COMP%]{position:fixed;width:288px;bottom:16px;left:50%;margin-left:-144px}}@media only screen and (min-width: 768px){.stb-toast-container.single[_ngcontent-%COMP%]{position:fixed;top:24px;right:24px}}"]
  });
  return ToastComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ToastModule = /*#__PURE__*/(() => {
  class ToastModule {}
  ToastModule.ɵfac = function ToastModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastModule)();
  };
  ToastModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ToastModule
  });
  ToastModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, ButtonModule]
  });
  return ToastModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of toast
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ToastComponent, ToastModule };
